import axios from "axios";
import { useEffect,useState } from "react";

export default function AddQuestion(props){
    
    const [data, setData]=useState([]);
    
    function getData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
    useEffect(()=>getData(),[]);
    function submitHandler(e){
       
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.post(`${process.env.REACT_APP_BASE_URL}api/question/secured/createQuestion`,data)
        .then(result=>{alert("Create Successfully!");window.location.href="/Question"})
        .catch(err=>alert(err.response.data));
    }

    return(<div className="form-container container">
            <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event(false)}>X</button>
        <div className="text-center">
            <h2>Create Question</h2>
        </div><hr />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                    <div className="col col-sm-6">
                        <div>
                            <textarea className="form-control" name="question" rows={10} placeholder="Question" required></textarea>
                        </div>
                         <div>
                            <input className="form-control" type="text" name="answer" placeholder="Answer" required />
                        </div>
                       
                    </div>
                    <div className="col col-sm-6">
                         <div>
                            <input className="form-control" type="text" name="option1" placeholder="Option1" required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option2" placeholder="option2" required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option3" placeholder="option3" required />
                        </div>
                        <div>
                            <input className="form-control" type="text" name="option4" placeholder="option4" required />
                        </div>
                        <div>
                           <select name="courseId" className="form-select" required>
                          {data.map((course)=>
                            <option value={course.id}>{course.name}</option>
                          )}
                        </select>
                        </div>
                        <div>
                            <button className="btn btn-color form-control">Submit</button>
                        </div> 
                    </div>
                </div> 
            </form>
        </div>
    </div>);
}